import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import "./vue-awesome-icons.js";
import Icon from "vue-awesome/components/Icon";
import VueFire from "vuefire";
import axios from "axios";
import { app, firebaseModule } from "@/firebase";
import VueClipboard from "vue-clipboard2";
import VueSweetalert2 from "vue-sweetalert2"
import 'sweetalert2/dist/sweetalert2.min.css';
// import VueAnalytics from "vue-analytics";
import "./assets/setupStyle.css";
import "./assets/style.css";

Vue.config.productionTip = false;

const global = Vue.prototype;

// Vue.use(Normalize)
Vue.use(VueClipboard);
Vue.use(VueSweetalert2, {
  confirmButtonColor: '#48b9ba',
  cancelButtonColor: '#894e99',
})
Vue.component("v-icon", Icon);
Vue.use(firebaseModule);
Vue.use(VueFire);
// Vue.component('v-select', vSelect)
global.$http = axios;
global.$toastEvents = [];

app.auth().onAuthStateChanged(function () {

  window.app = new Vue({
    router,
    render: (h) => h(App),
  }).$mount("#app");

  if (process.env.VUE_APP_DEPLOYMENT_TYPE === "production") {
    // todo: enable analytics
    // Vue.use(VueAnalytics, { id: "UA-121198315-2", router });
  }
});
